<template>
  <div>
    <SearchComponent
      :isAdd="true"
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      :total="total"
      :pageParams="queryParams"
      @pageChange="getList"
    >
      <template slot="solts" slot-scope="scope">
        <el-button
          v-hasPermi="[authIdentity + ':print']"
          class="button"
          type="text"
          size="small"
          @click="handleFormat(scope.data, scope.$index)"
          >打印</el-button
        >
        <el-button
          v-hasPermi="[authIdentity + ':detail']"
          @click="handleDetail(scope.data, scope.$index)"
          type="text"
          size="small"
          class="button"
          >详情</el-button
        >
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component ref="myform" :is="currentView"></component>
      <span slot="footer">
        <el-button class="batch-button" @click="cancel">取 消</el-button>
        <el-button class="line-button" @click="submitFrom">确 定</el-button>
      </span>
    </Mdialog>

    <Mdialog
      title="选择打印类型"
      :visible.sync="formatDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="formatDialogVisible = false"
    >
      <el-form :model="printInfo" ref="printFormatForm">
        <el-form-item prop="printFormat" :rules="[{ required: true, message: '请选择打印类型', trigger: 'change' }]">
          <el-select v-model="printInfo.printFormat" placeholder="请选择">
            <el-option label="采摘批次" :value="1" v-hasPermi="[authIdentity + ':pickPrint']"></el-option>
            <el-option
              label="干皮批次"
              :value="2"
              v-hasPermi="[authIdentity + ':dryPrint']"
              v-if="rowData.dryBizNo"
            ></el-option>
            <el-option
              label="溯源码"
              :value="3"
              v-hasPermi="[authIdentity + ':traceabilityPrint']"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button class="line-button" @click="handlePrint">确 定</el-button>
      </span>
    </Mdialog>

    <el-dialog
      title="打印预览"
      class="dialog"
      :visible.sync="printInfo.printDialog"
      :close-on-click-modal="false"
      width="60%"
      @close="printInfo.printDialog = false"
      destroy-on-close
      append-to-body
      :top="'5vh'"
    >
      <PrintBox ref="printBox" />
    </el-dialog>

    <el-drawer title :visible.sync="drawer" :show-close="true" :destroy-on-close="true" :size="500">
      <div slot="title"></div>
      <component :ref="currentView" :is="currentView" :data="row"></component>
    </el-drawer>
  </div>
</template>

<script>
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import PrintBox from '@/components/PrintBox'
import TablePublic from '@/components/tablePublic'
import Preview from './components/Preview'

import { getDropPlantationList } from '@/api/manage/plantation'
import { getPrintPcList, getTraceabilityNode } from '@/api/manage/report'

export default {
  name: 'Print',
  components: {
    TablePublic,
    SearchComponent,
    PrintBox,
    Mdialog,
    Preview,
  },
  data() {
    const _this = this

    return {
      authIdentity: 'traceability:print',
      dialogVisible: false,
      title: '',
      currentView: 'Preview',
      // operatDialog: {
      //   visible: false, //是否展示
      //   title: '', //弹窗标题
      //   currentView: null, //当前组件
      //   width: '', //弹窗宽度
      //   type: '', //提交类型
      //   data: {}, //弹窗数据
      // },
      colLists: [
        {
          prop: 'bizNo',
          label: '采购批次',
          isTrue: true,
          width: 120,
        },
        {
          prop: 'plantationName',

          label: '果园名称',
          isTrue: true,
          width: 160,
          align: 'left',
        },
        {
          prop: 'cropBrandKeyValue',
          label: '产品名称',
          isTrue: true,
        },
        {
          prop: '',
          width: 160,
          label: '规格',
          isTrue: true,
          align: 'left',
          formatter(row) {
            const arr = [
              row.ripenessLevelSpecAttrValueKey,
              row.locDetails?.slice(row.locDetails?.lastIndexOf(',') + 1),
              row.cultivationMethodSpecValueKey,
            ]
            return arr.filter((item) => !!item).join('-')
          },
        },
        {
          prop: 'pickingDateTime',
          label: '采摘日期',
          isTrue: true,
          width: 110,
        },
        {
          prop: 'freightDateTime',
          label: '运输日期',
          isTrue: true,
          width: 110,
        },
        {
          prop: 'inspectionDateTime',
          label: '验收日期',
          isTrue: true,
          width: 110,
        },
        {
          prop: 'freshTime',
          label: '生产加工日期',
          isTrue: true,
          width: 110,
        },
        {
          prop: 'dryBizNo',
          label: '干皮批次',
          isTrue: true,
          width: 110,
        },
        {
          prop: 'locationTime',
          label: '干皮生产日期',
          isTrue: true,
          width: 120,
        },
        {
          prop: 'productName',
          label: '产品名称',
          isTrue: true,
        },
        {
          prop: '',
          label: '规格',
          width: 300,
          isTrue: true,
          align: 'left',
          formatter(row) {
            const arr = [
              row.ripenessLevelSpecAttrValueKey,
              row.locDetails?.slice(row.locDetails?.lastIndexOf(',') + 1),
              row.cultivationMethodSpecValueKey,
              _this.parseTime(row.locationTime, '{y}'),
              row.plantationName,
            ]
            return arr.filter((item) => !!item).join('-')
          },
        },
        {
          prop: 'inspectionInboundDateTime',
          label: '干皮验收日期',
          isTrue: true,
          width: 120,
        },
        {
          prop: 'productInboundDateTime',
          label: '产品入库日期',
          isTrue: true,
          width: 120,
        },
        {
          prop: 'stage',
          label: '阶段',
          isTrue: true,
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      total: 0,
      tableData: [],
      selectOrInputList: [
        {
          model: 'plantationId',
          placeholder: '请选择果园',
          value: 'id',
          label: 'name',
          list: [],
          type: 'select',
        },
        {
          model: 'bizNo',
          placeholder: '请输入批次',
          class: 'home',
          type: 'input',
        },
      ],

      drawer: false,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },

      row: {},

      formatDialogVisible: false,
      printInfo: {
        printDialog: false,
        type: 'traceabilityPick',
        list: [],
        printFormat: null,
      },
      rowData: {},
    }
  },
  mounted() {
    this.getPlantationList()
    this.getList()
  },
  methods: {
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      getPrintPcList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items.map((item) => {
              // item.visible = false
              // item.locName = this.formatLocal(item.locDetails, 3)
              // item.visitedDate = this.parseTime(item.visitedDateTime, '{y}-{m}-{d}')
              // item.statusText = CONSTANTS.getStatusConversion(item.status, 'taskStatus')
              // item.readyForHarvest = CONSTANTS.getStatusConversion(item.readyForHarvestStatus, 'readyForHarvestStatus')
              return item
            })
            this.total = res.data.totalCount
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getPlantationList() {
      getDropPlantationList().then((res) => {
        this.selectOrInputList[0].list = res.data.map((item) => {
          item.name = `${item.bizNo}-${item.name}`
          return item
        })
      })
    },
    handleFormat(data) {
      this.rowData = data

      this.formatDialogVisible = true
    },
    handleDetail(row) {
      this.row = row
      
      this.currentView = 'Preview'
      this.drawer = true
    },
    handlePrint() {
      this.$refs.printFormatForm.validate(async (valid) => {
        if (valid) {
          this.formatDialogVisible = false

          

          if (this.printInfo.printFormat === 1) {
            this.printInfo.type = 'traceabilityPick'
            const { bizNo, tenantId, dryBizNo } = this.rowData
            const res = await getTraceabilityNode({ bizNo, tenantId, dryBizNo })
            if (res.flag && res.code === 200) {
              this.rowData.customerName = res.data[0]?.customerName
              this.rowData.customerAbbrev = res.data[0]?.customerAbbrev
             }
          } else if (this.printInfo.printFormat === 2) {
            this.printInfo.type = 'traceabilityDry'
          } else if (this.printInfo.printFormat === 3) {
            this.printInfo.type = 'traceability'
          }

          this.printInfo.list = [this.rowData]

          this.printInfo.printDialog = true
          this.$nextTick(() => {
            this.$refs.printBox.init(this.printInfo)
          })
        }
      })
    },
    submitFrom() {},
    cancel() {
      this.dialogVisible = false
    },
    add() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.title = '新增采购计划'
        this.currentView = 'myform'
        this.type = 'add'
      })
    },
    handleSearch(query) {
      this.queryParams = Object.assign(this.queryParams, query)
      this.queryParams.pageNo = 1
      this.getList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
      }
      this.getList()
    },
  },
}
</script>
<style scoped lang="less">
@import '~@/assets/tableList.less';
// @import '../../../../assets/form.less';
</style>
